import { createSelector } from "reselect";

const selectSystemReducer = state => state.system;

export const selectGradientData = createSelector(
    [selectSystemReducer],
    (system) => system.gradientData
); 
export const selectGradient = createSelector(
    [selectSystemReducer],
    (system) => system.gradient
);
export const selectBgIsChanging = createSelector(
    [selectSystemReducer],
    (system) => system.bgIsChanging
);
export const selectGradientA = createSelector(
    [selectSystemReducer],
    (system) => system.gradientA
);
export const selectGradientB = createSelector(
    [selectSystemReducer],
    (system) => system.gradientB
);
export const selectDisplayedGradient = createSelector(
    [selectSystemReducer],
    (system) => system.displayedGradient
);
export const selectSystemNotification = createSelector(
    [selectSystemReducer],
    (system) => system.systemNotification
);
export const selectCriticalMessage = createSelector(
    [selectSystemReducer],
    (system) => system.criticalMessage
);
export const selectChecklistSportDefault = createSelector(
    [selectSystemReducer],
    (system) => system.checklistSportDefault
);
export const selectChecklistYearDefault = createSelector(
    [selectSystemReducer],
    (system) => system.checklistYearDefault
);
export const selectChecklistManufacturerDefault = createSelector(
    [selectSystemReducer],
    (system) => system.checklistManufacturerDefault
);
export const selectChecklistSeriesDefault = createSelector(
    [selectSystemReducer],
    (system) => system.checklistSeriesDefault
);
export const selectChecklistCardTypeDefault = createSelector(
    [selectSystemReducer],
    (system) => system.checklistCardTypeDefault
);
export const selectChecklistCardTypeCategoryDefault = createSelector(
    [selectSystemReducer],
    (system) => system.checklistCardTypeCategoryDefault
);